import { createTheme } from 'react-data-table-component';

/**
 * Colores de todas las tablas de datos, sacados de las variables del tema.
 *
 * `createTheme('default', …)` mezcla estos valores en el tema por defecto de la
 * librería, así que alcanza a cada `DataTable` de la aplicación sin tocar las
 * pantallas. Como son `var(--…)`, al cambiar de tema cambian también las tablas.
 *
 * Se llama una sola vez, al arrancar, desde `index.js`.
 */
export const aplicarTemaDeTablas = (): void => {
  createTheme('default', {
    text: {
      primary: 'var(--c-ink)',
      secondary: 'var(--c-ink-soft)',
      disabled: 'var(--c-ink-faint)',
    },
    background: {
      default: 'var(--c-surface)',
    },
    context: {
      background: 'var(--c-brand-100)',
      text: 'var(--c-brand-900)',
    },
    divider: {
      default: 'var(--c-line)',
    },
    button: {
      default: 'var(--c-ink-soft)',
      focus: 'var(--c-brand-100)',
      hover: 'var(--c-brand-100)',
      disabled: 'var(--c-ink-faint)',
    },
    selected: {
      default: 'var(--c-brand-100)',
      text: 'var(--c-ink)',
    },
    highlightOnHover: {
      default: 'var(--c-brand-100)',
      text: 'var(--c-ink)',
    },
    striped: {
      default: 'var(--c-surface-alt)',
      text: 'var(--c-ink)',
    },
  });
};

export default aplicarTemaDeTablas;
